export default "__VITE_ASSET__C5V_9R$P__"